module.exports = __webpack_public_path__ + "static/media/SupplierDataSample.1763d90a.xlsx";